import { NAME_TOKEN_ENTITY_SWITH_USER, NAME_TOKEN_HREF_SWITH_USER } from '@/lib/auth/session'
import { getListRouteAvailableWithoutEntity, isUtilityRoute } from '@/lib/routes/getAllRoutes'
import { getListRoutesHome } from '@/lib/routes/getListRoutesHome'
import { EntityList } from '@/types/Entity'

export const getRouteDefault = async ({
  router,
  loggedUserRoles,
  entity,
  isUserAdminBackOffice,
}) => {
  // Utiliser sessionStorage pour isoler par onglet
  const hrefReturn = sessionStorage.getItem(NAME_TOKEN_HREF_SWITH_USER)

  //si on est admin back office et que l'on a un href retour on le supprime et on redirige vers l'url retour
  if (isUserAdminBackOffice && hrefReturn) {
    sessionStorage.removeItem(NAME_TOKEN_HREF_SWITH_USER)
    const entityReturn = sessionStorage.getItem(NAME_TOKEN_ENTITY_SWITH_USER)
    sessionStorage.removeItem(NAME_TOKEN_ENTITY_SWITH_USER)
    return {
      href: hrefReturn,
      as: hrefReturn,
      entity: entityReturn ? entityReturn : null,
      message: `admin return back office ${hrefReturn}`,
    }
  } else {
    //sinon on cherche si la route courant est authorisée pour l'utilisateur sinon on la redirige vers la page par defaut
    const urlHome = getListRoutesHome(loggedUserRoles, entity)

    if (!!urlHome) {
      //on test si l'url actuelle est une page de l'application
      const allRoutes = getListRouteAvailableWithoutEntity(loggedUserRoles)
      const getRoute = allRoutes.filter(r => r.href === router.pathname)
      if (!!getRoute && getRoute.length > 0) {
        // Une page utilitaire n'appartient à aucun module : on y reste sans basculer d'entité.
        const findGoodRoute = getRoute.find(r => isUtilityRoute(r) || r.entity.includes(entity))
        if (!findGoodRoute) {
          const firstRoute = getRoute?.[0]
          return {
            href: firstRoute?.href,
            as: firstRoute?.as,
            entity: firstRoute?.entity[0],
            message: 'route first',
          }
        } else {
        }
      } else {
        return {
          href: urlHome.href,
          as: urlHome.as,
          entity: entity,
          message: `route default ${router.pathname}`,
        }
      }
    } else {
      // Jamais une page utilitaire comme accueil de repli (cf. isUtilityRoute).
      const urlHomeWithoutEntity = getListRouteAvailableWithoutEntity(loggedUserRoles).filter(
        r => !isUtilityRoute(r)
      )
      if (urlHomeWithoutEntity.length) {
        const firstRoute = urlHomeWithoutEntity?.[0]
        return {
          href: firstRoute.href,
          as: firstRoute.as,
          entity: firstRoute.entity[0],
          message: `route default without entity ${router.pathname}`,
        }
      }

      return { href: null, as: null, entity: EntityList.PHARMEDIGROUP, message: 'route not found' }
    }
  }
}

export default getRouteDefault
